module.exports.main = `
  INSERT INTO fin.journalentry (
      origin, company, txn_id, txn_date,
      doc_no, currency, private_note
  )
  SELECT origin
       , company
       , txn_id
       , txn_date
       , data->>'DocNumber' as doc_no
       , (data->'CurrencyRef'->>'value')::fin.currency_type as currency
       , (data->>'PrivateNote') as private_note
  FROM raw
`
module.exports.line = `
  INSERT INTO fin.journalentry_line (
      origin, company, txn_id, line_num,
      account_id, entry_type, customer_id, amount, description
  )
  SELECT origin
       , company
       , txn_id
       , line_num
       , (line->'JournalEntryLineDetail'->'AccountRef'->>'value')::INTEGER
         as account_id
       , LOWER(line->'JournalEntryLineDetail'->>'PostingType')::fin.entry_type
         as entry_type
       , (line->'JournalEntryLineDetail'->'Entity'->'EntityRef'->>'value')::INTEGER
         as customer_id
       , (line->'Amount')::NUMERIC as amount
       , (line->'Description') as description
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line')
             WITH ORDINALITY AS l(line, line_num) ON TRUE
  WHERE line->>'DetailType' = 'JournalEntryLineDetail'
    AND line->'JournalEntryLineDetail'->'PostingType' IS NOT NULL
`

module.exports.rawCustomerIds = `
  SELECT origin
       , company
       , (line->'JournalEntryLineDetail'->'Entity'->'EntityRef'->>'value')::INTEGER
         as customer_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line ON TRUE
  WHERE line->>'DetailType' = 'JournalEntryLineDetail'
    AND line->'JournalEntryLineDetail'->'PostingType' IS NOT NULL
`

module.exports.rawAccountIds = `
  SELECT origin
       , company
       , (line->'JournalEntryLineDetail'->'EntityRef'->>'value')::INTEGER
         as account_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line ON TRUE
  WHERE line->>'DetailType' = 'JournalEntryLineDetail'
    AND line->'JournalEntryLineDetail'->'PostingType' IS NOT NULL
`
